import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { Spinner } from '@/shared/components/Spinner';
import { useAuth } from '@/app/providers/AuthProvider';
import styles from './RequireAuth.module.scss';

/**
 * Protege as rotas internas.
 *
 * Enquanto a sessão é confirmada no servidor, a tela mostra progresso em vez de
 * piscar o login e voltar — recarregar uma página interna não deve parecer que a
 * sessão caiu.
 *
 * O destino original vai no estado da navegação, para o login devolver o usuário
 * exatamente onde ele estava.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'checking') {
    return (
      <div className={styles.loading}>
        <Spinner size={24} label="Verificando sua sessão" />
      </div>
    );
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
